<template>
  <div style="width: 100%; height: 98%; overflow: auto">
    <!-- 检索部分 -->
    <div class="status-container">
      <el-row>
        <el-col :span="3" :offset="1" style="text-align: left; font-size: 18px; font-weight: bold">
          <el-form-item label="项目年份：">
            <el-date-picker
                v-model="project_year"
                type="years"
                value-format="YYYY"
                placeholder="选择年份"
                @change="getBusData"
                style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="3" :offset="1" style="text-align: left; font-size: 18px; font-weight: bold">
          <el-form-item label="项目状态：">
            <el-select v-model="project_status" placeholder="项目状态" clearable @change="getBusData">
              <el-option
                  v-for="item in projectStatusList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="3" :offset="1" style="text-align: left; font-size: 18px; font-weight: bold">
          <el-form-item label="项目名称：">
            <el-select v-model="project_id" placeholder="请选择" clearable @change="getBusData">
              <el-option
                  v-for="item in projectList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="1" :offset="1" style="text-align: right;">
          <span class="color-block budget"></span>
        </el-col>
        <el-col :span="1" style="text-align: left;">
          <span class="status-text">预算</span>
        </el-col>
        <el-col :span="1" style="text-align: right;">
          <span class="color-block cost"></span>
        </el-col>
        <el-col :span="1" style="text-align: left;">
          <span class="status-text">支出</span>
        </el-col>
        <el-col :span="1" style="text-align: right;">
          <span class="color-block income"></span>
        </el-col>
        <el-col :span="1" style="text-align: left;">
          <span class="status-text">收入</span>
        </el-col>
        <el-col :span="1" style="text-align: right;">
          <span class="color-block bonus"></span>
        </el-col>
        <el-col :span="1" style="text-align: left;">
          <span class="status-text">提成</span>
        </el-col>
      </el-row>
    </div>

    <!-- tab部分 -->
<!--    <el-row style="margin-top: 10px; padding: 0 10px">
      <el-col :span="24" style="width: 100%; height: 98%">
        <el-tabs v-model="activeName" type="border-card" stretch>
          &lt;!&ndash; 预算 &ndash;&gt;
          <el-tab-pane label="预算" name="budget">
            <el-table :data="paginatedBudgetData" style="width: 100%">
              <el-table-column prop="id" label="预算编号" width="150" />
              <el-table-column prop="type_name" label="预算类型" width="120" />
              <el-table-column prop="amount" label="金额" width="100" />
              <el-table-column prop="create_user_name" label="创建人" width="120" />
              <el-table-column prop="create_time" label="创建时间" width="150" />
              <el-table-column prop="reason" label="预算理由" />
              <el-table-column prop="approve_user_name" label="审批人" width="120" />
              <el-table-column prop="approve_time" label="审批时间" width="150" />
              <el-table-column prop="approve_reason" label="审批理由" />
            </el-table>
            <el-pagination
                @size-change="handleSizeChange('budget', $event)"
                @current-change="handleCurrentChange('budget', $event)"
                :current-page="pagination.budget.currentPage"
                :page-sizes="[5, 10, 20, 30]"
                :page-size="pagination.budget.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="budgetData.length"
            />
          </el-tab-pane>

          &lt;!&ndash; 支出 &ndash;&gt;
          <el-tab-pane label="支出" name="cost">
            <el-table :data="paginatedCostData" style="width: 100%">
              <el-table-column prop="id" label="支出编号" width="150" />
              <el-table-column prop="type_name" label="支出类型" width="120" />
              <el-table-column prop="amount" label="金额" width="100" />
              <el-table-column prop="cost_user_name" label="支出人" width="120" />
              <el-table-column prop="cost_date" label="支出日期" width="150" />
              <el-table-column prop="reason" label="支出理由" />
              <el-table-column prop="approve_user_name" label="审批人" width="120" />
              <el-table-column prop="approve_time" label="审批时间" width="150" />
              <el-table-column prop="approve_reason" label="审批理由" />
            </el-table>
            <el-pagination
                @size-change="handleSizeChange('cost', $event)"
                @current-change="handleCurrentChange('cost', $event)"
                :current-page="pagination.cost.currentPage"
                :page-sizes="[5, 10, 20, 30]"
                :page-size="pagination.cost.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="costData.length"
            />
          </el-tab-pane>

          &lt;!&ndash; 收入 &ndash;&gt;
          <el-tab-pane label="收入" name="income">
            <el-table :data="paginatedIncomeData" style="width: 100%">
              <el-table-column prop="id" label="收入编号" width="150" />
              <el-table-column prop="type_name" label="收入类型" width="120" />
              <el-table-column prop="amount" label="金额" width="100" />
              <el-table-column prop="income_date" label="收入日期" width="150" />
              <el-table-column prop="approve_user_name" label="审批人" width="120" />
              <el-table-column prop="approve_time" label="审批时间" width="150" />
              <el-table-column prop="approve_reason" label="审批理由" />
              <el-table-column prop="remark" label="描述" />
            </el-table>
            <el-pagination
                @size-change="handleSizeChange('income', $event)"
                @current-change="handleCurrentChange('income', $event)"
                :current-page="pagination.income.currentPage"
                :page-sizes="[5, 10, 20, 30]"
                :page-size="pagination.income.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="incomeData.length"
            />
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>-->

    <!-- 循环展示部分 -->
    <el-row style="padding-top: 10px; overflow-y: auto; max-height: 90%">
      <template v-for="data in busData" :key="data.id">
        <el-col :span="12" style="font-size: large; line-height: 50px; text-align: center; padding: 0 80px; width: 100%; margin-bottom: 10px">
          <el-row class="project-name">
            <el-col :span="12" style="text-align: center">{{ data.name }}</el-col>
            <el-col :span="3" class="val1">{{ data.total_budget }}</el-col>
            <el-col :span="3" class="val2">{{ data.total_cost }}</el-col>
            <el-col :span="3" class="val3">{{ data.total_income }}</el-col>
            <el-col :span="3" class="val4">{{ data.total_bonus }}</el-col>
          </el-row>
<!--          <el-row class="project-name">-->
<!--            <el-col :span="6">{{ data.start_year }}</el-col>-->
<!--            <el-col :span="12" style="text-align: center">{{ data.name }}</el-col>-->
<!--            <el-col :span="4" style="text-align: right">{{ data.project_status_name }}</el-col>-->
<!--          </el-row>-->
<!--          <el-row>-->
<!--            <el-col :span="6" class="val1">{{ data.total_budget }}</el-col>-->
<!--            <el-col :span="6" class="val2">{{ data.total_cost }}</el-col>-->
<!--            <el-col :span="6" class="val3">{{ data.total_income }}</el-col>-->
<!--            <el-col :span="6" class="val4">{{ data.total_bonus }}</el-col>-->
<!--          </el-row>-->
        </el-col>
      </template>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "PrjProjectFinancial",
  data() {
    return {
      busData: [],
      projectList: [],
      project_id: "",
      project_status: "",
      project_year: "",
      activeName: "budget",
      budgetData: [],
      costData: [],
      incomeData: [],
      // 为每个tab维护独立的分页参数
      pagination: {
        budget: { currentPage: 1, pageSize: 5 },
        cost: { currentPage: 1, pageSize: 5 },
        income: { currentPage: 1, pageSize: 5 },
      },
    };
  },
  computed: {
    projectStatusList() {
      return this.$store.getters["core/getDictList"]("project_status");
    },
    // 计算当前tab的分页数据
    paginatedBudgetData() {
      const { currentPage, pageSize } = this.pagination.budget;
      const start = (currentPage - 1) * pageSize;
      const end = start + pageSize;
      return this.budgetData.slice(start, end);
    },
    paginatedCostData() {
      const { currentPage, pageSize } = this.pagination.cost;
      const start = (currentPage - 1) * pageSize;
      const end = start + pageSize;
      return this.costData.slice(start, end);
    },
    paginatedIncomeData() {
      const { currentPage, pageSize } = this.pagination.income;
      const start = (currentPage - 1) * pageSize;
      const end = start + pageSize;
      return this.incomeData.slice(start, end);
    },
  },
  created() {
    this.getProjectListByAdmin();
    this.getBusData();
  },
  methods: {
    async getBusData() {
      let params = {
        project_year: this.project_year,
        project_id: this.project_id,
        project_status: this.project_status,
      };
      let financialData = await this.$http("prjBoardService.getProjectFinancialData", params);
      this.busData = financialData.projectList;
      this.budgetData = financialData.budgetData || [];
      this.costData = financialData.costData || [];
      this.incomeData = financialData.incomeData || [];
    },
    async getProjectListByAdmin() {
      this.projectList = await this.$http("prjBoardService.getProjectListByCurrentUser");
    },
    // 分页事件处理
    handleSizeChange(tab, val) {
      this.pagination[tab].pageSize = val;
      this.pagination[tab].currentPage = 1; // 重置到第一页
    },
    handleCurrentChange(tab, val) {
      this.pagination[tab].currentPage = val;
    },
  },
};
</script>

<style lang="less" scoped>
.project-name {
  margin-bottom: 5px;
  color: #fff;
  font-size: 22px;
  background-color: rgba(112, 110, 110, 0.44);
}

.val1 {
  //margin-bottom: 5px;
  background-color: skyblue;
  color: #fff;
}

.val2 {
  //margin-bottom: 5px;
  background-color: #FC02029D;
  color: #fff;
}

.val3 {
  //margin-bottom: 5px;
  background-color: #EA9C0BBA;
  color: #fff;
}

.val4 {
  //margin-bottom: 5px;
  background-color: #cba5eed8;
  color: #fff;
}

.status-container {
  padding-top: 20px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  position: sticky;
  top: 0;
  z-index: 100;
}

.color-block {
  display: inline-block;
  width: 100%; /* 色块宽度 */
  height: 30px; /* 色块高度 */
  border-radius: 6px; /* 圆角 */
}

.budget {
   background-color: skyblue; /* 蓝色 */
 }

.cost {
  background-color: #FC02029D; /* 红色 */
}

.income {
  background-color: #EA9C0BBA; /* 橙色 */
}

.bonus {
  background-color: #cba5eed8; /* 黄色 */
}

.abort {
  background-color: rgba(112,110,110,0.65);/* 灰色 */
}


.status-text {
  font-size: 18px; /* 文字更大 */
  font-weight: bold; /* 文字加粗 */
  color: #333; /* 文字颜色 */
  width: 80%; /* 文字宽度与色块一致 */
  text-align: left; /* 文字居中 */
  margin-left: 10px;
}
</style>